<div class="row page-header">
    <div class="col-12">
        <h1>{{ meeting().name }}<small> Select agenda items to move through your meeting</small></h1>
    </div>
</div>
<div>
    <div class="row">
        <div class="col-lg-2" style="border-right: 1px solid lightgray; display: flex; flex-flow: column" appAutoSize>
            <div class="row">
                <div class="col-12">
                    <h3 class="meeting-page-header">Agenda</h3>
                    @if (leadReconnecting()) {
                        <div class="alert alert-warning" style="padding: 6px 10px; font-size: 0.85rem" role="status">
                            Waiting for <strong>{{ leadName() }}</strong> to reconnect...
                        </div>
                    }
                    @if (!isLead() && !leadReconnecting()) {
                        <div class="alert alert-info" style="padding: 6px 10px; font-size: 0.85rem" role="status">
                            <strong>{{ leadName() }}</strong> is leading. Your view follows theirs.
                        </div>
                    }
                    <ul class="meeting-page-list">
                        @for (page of pages(); track page; let i = $index) {
                            <li
                                (click)="setActivePage(i)"
                                [class.active]="activePageIndex() === i"
                                [class.follower-locked]="!isLead()"
                                class="meeting-page-item"
                            >
                                @if (activePageIndex() === i) {
                                    <div>{{ page.title }} - {{ currentPageTimeFormatted() }} of {{ page.duration }} min</div>
                                } @else {
                                    <div>{{ page.title }}</div>
                                }
                            </li>
                        }
                    </ul>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <h3 class="meeting-page-header">
                        Attendees
                        <small>{{ roster().length }} in meeting</small>
                    </h3>
                    <ul class="meeting-attendee-list" style="list-style: none; padding-left: 0">
                        @for (attendee of roster(); track attendee.userId) {
                            <li style="display: flex; align-items: center; justify-content: space-between; padding: 3px 0">
                                <span>
                                    {{ attendee.displayName }}
                                    @if (attendee.userId.toLowerCase() === leadUserId().toLowerCase()) {
                                        <span class="badge bg-primary" style="margin-left: 5px">Lead</span>
                                    }
                                </span>
                                @if (isLead() && attendee.userId.toLowerCase() !== leadUserId().toLowerCase()) {
                                    <button
                                        class="btn btn-outline-secondary btn-sm"
                                        (click)="reassignLead(attendee.userId)"
                                        title="Make this attendee the meeting lead"
                                    >
                                        Make lead
                                    </button>
                                }
                            </li>
                        }
                    </ul>
                </div>
            </div>

            <div class="row" style="margin-top: auto">
                <div class="col-12" style="display: flex; justify-content: end; margin-top: 10px">
                    <button class="btn btn-primary" (click)="leaveOrEndMeeting()">
                        {{ isLead() ? 'End Meeting' : 'Leave Meeting' }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="row">
                    <h3 class="meeting-page-header">{{ activePage() ? activePage().title : 'No active page' }}</h3>
                    @if (activePage() && activePage().subheading) {
                        <div class="active-page-subheader">
                            <h5 class="meeting-page-header">{{ activePage().subheading }}</h5>
                        </div>
                    }
                </div>

                <div class="row">
                    <!-- @if(activePage().pageType === 0) {
                <div>This is the Title Page</div>
                } @if(activePage().pageType === 1) {
                <div>This is the Check-In page</div>
                } @if(activePage().pageType === 2) {
                <app-goals [meetingId]="meeting().id"></app-goals>
                } @if(activePage().pageType === 3) {
                <app-rocks [meetingId]="meeting().id" [meetings]="meetings()"></app-rocks>
                }  -->

                    @switch (activePage().pageType) {
                        @case (MeetingPageType.TitlePage) {
                            <div>This is the Title Page</div>
                        }
                        @case (MeetingPageType.Checkin) {
                            <div></div>
                        }
                        @case (MeetingPageType.Metrics) {
                            <app-goals [meetingId]="meeting().id"></app-goals>
                        }
                        @case (MeetingPageType.Rocks) {
                            <app-rocks
                                [meetingId]="meeting().id"
                                [meetings]="meetings()"
                                [meeting]="meeting()"
                                [isActiveMeeting]="true"
                            ></app-rocks>
                        }
                        @case (MeetingPageType.Headlines) {
                            <app-headlines
                                [meetingId]="meeting().id"
                                [meetings]="meetings()"
                                [meeting]="meeting()"
                                [isHeadline]="true"
                                [isActiveMeeting]="true"
                            ></app-headlines>
                        }
                        @case (MeetingPageType.Todos) {
                            <app-to-dos [meetingId]="meeting().id" [meetings]="meetings()" [meeting]="meeting()"></app-to-dos>
                        }
                        @case (MeetingPageType.Oppurtunities) {
                            <app-headlines
                                [meetingId]="meeting().id"
                                [meetings]="meetings()"
                                [meeting]="meeting()"
                                [isHeadline]="false"
                                [isActiveMeeting]="true"
                            ></app-headlines>
                        }
                        @case (MeetingPageType.Wrapup) {
                            <app-wrap-up
                                [meetingId]="meeting().id"
                                [meetings]="meetings()"
                                [meeting]="meeting()"
                                [pages]="pages()"
                            ></app-wrap-up>
                        }
                        @case (MeetingPageType.NotesBox) {
                            <div>This is the Notes Box Page</div>
                        }
                        @case (MeetingPageType.ExternalPage) {
                            <div>This is the External Page</div>
                        }
                        @case (MeetingPageType.Whiteboard) {
                            <div>
                                <quill-editor
                                    appAutoSize
                                    [padding]="85"
                                    [minHeight]="100"
                                    #quillEditorRef
                                    style="width: 100%"
                                    [ngModel]="meeting().whiteBoardContent"
                                    (ngModelChange)="onWhiteBoardContentChange($event)"
                                    (onFocus)="onWhiteboardFocus()"
                                    (onBlur)="onWhiteboardBlur()"
                                    name="whiteBoardContent"
                                    [modules]="editorModules"
                                >
                                </quill-editor>
                            </div>
                        }
                        @case (MeetingPageType.Mixed) {
                            <div>This is the Mixed Page</div>
                        }
                        @default {
                            <p>Unknown page type</p>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
</div>
